import type { ReactNode } from 'react';

import ActionDrawer from '@polyai/ui/components/atoms/ActionDrawer';
import Button from '@polyai/ui/components/atoms/Button';
import { useSidebarOptional } from '@polyai/ui/components/organisms/Sidebar';

interface Props {
  open: boolean;
  disableSubmit?: boolean;
  isSubmitting: boolean;
  onDiscard: () => void;
  onSubmit: () => void;
  secondaryAction?: ReactNode;
  width?: number;
  buttonsOnly?: boolean;
  disableDiscard?: boolean;
}

const SaveChangesDrawer = ({
  open,
  disableSubmit,
  isSubmitting,
  onDiscard,
  onSubmit,
  secondaryAction,
  width,
  buttonsOnly,
  disableDiscard = false,
}: Props) => {
  const isMainNavOpen = useSidebarOptional()?.open ?? false;
  return (
    <ActionDrawer
      cornerVariant="pill"
      isMainNavOpen={isMainNavOpen}
      open={open}
      secondaryAction={secondaryAction}
      text={!buttonsOnly ? 'Unsaved changes on this page' : undefined}
      width={width}
    >
      <Button
        key="discard"
        disabled={disableDiscard}
        label="Discard changes"
        variant="SECONDARY"
        inverse
        onClick={onDiscard}
      />
      <Button
        key="save"
        disabled={disableSubmit}
        label="Save"
        loading={isSubmitting}
        variant="BRAND"
        inverse
        onClick={onSubmit}
      />
    </ActionDrawer>
  );
};

export default SaveChangesDrawer;
